import merge from 'lodash-es/merge';
import getDefaultStyle from '../css/defaultStyle';
import updateStyle from '../css/updateStyle';
import lookAndFeel from '../lookAndFeel';
import updateStyleByRef from '../css/updateStyleByRef';
import frameProps from '../css/frameProps';
import { updateClasses, getDefaultControl } from './splitter.defaults';
import Control from './control';
import uniqueId from '../uniqueId';

const verticalFrame = {
  position: 'absolute',
  display: 'block',
  overflow: 'hidden',
  top: '8px',
  left: '8px',
  width: '8px',
  height: '200px',  
  cursor: 'ew-resize'
};

const horisontalFrame = {
  position: 'absolute',
  display: 'block',
  overflow: 'hidden',
  top: '8px',
  left: '8px',
  height: '8px',
  width: '100px',  
  cursor: 'ns-resize'
};


export default class Splitter extends Control {

  constructor(instance, path, nicePath) {
    super(instance, path, nicePath);
    this.draggable = true;
    
  }

  get fromControl(){
    return this._controlOptions.splitFrom && (this.instance.controls[this._controlOptions.splitFrom] || this.instance.getControl(this._controlOptions.splitFrom));
  }

  get toControl(){
    return this._controlOptions.splitTo && (this.instance.controls[this._controlOptions.splitTo] || this.instance.getControl(this._controlOptions.splitTo));
  }

  syncControls(render){
    // const options = this._controlOptions;
    const options = this.options;
    const fromControl = this.fromControl;
    const toControl = this.toControl;
    if(!fromControl && !toControl) {return;}
    
    if(fromControl){    
      if(options.orientation=='horizontal'){
        if(fromControl.left!==undefined){
          this.left = fromControl.left;            
        }

        if(fromControl.width!==undefined){
          this.width = fromControl.width;            
        }

        if(fromControl.right!==undefined){
          this.right = fromControl.right;
        }

      }else{
        if(fromControl.top!==undefined){
          this.top = fromControl.top;            
        }
        
        if(fromControl.height!==undefined){
          this.height = fromControl.height;
        }

        if(fromControl.bottom!==undefined){
          this.bottom = fromControl.bottom;            
        }        
      }      
    }

    if(toControl){
      
      if(options.orientation=='horizontal'){
        
        if(!fromControl){
          if(toControl.left!==undefined){
            this.left = toControl.left;            
          }

          if(toControl.width!==undefined){
            this.width = toControl.width;            
          }

          if(toControl.right!==undefined){
            this.right = toControl.right;
          }
        }
        
      }else{        
        
        if(!fromControl){
          if(toControl.top!==undefined){
            this.top = toControl.top;            
          }
          
          if(toControl.height!==undefined){
            this.height = toControl.height;
          }

          if(toControl.bottom!==undefined){
            this.bottom = toControl.bottom;            
          }         
        }
      }
    }

    let left = parseInt(this.left);
    let top = parseInt(this.top);
    let size = parseInt(options.thickness);

    if(fromControl){
      if(options.orientation=='horizontal'){
        const fromTop = parseInt(fromControl.top);
        if(top<fromTop){
          top = fromControl.top;
        }
      }else{
        const fromLeft = parseInt(fromControl.left);
        if(left<fromLeft){
          left = fromLeft;
        }
      }
    }

    if(toControl){
      if(options.orientation=='horizontal'){
        const oldTop = parseInt(toControl.top);
        
        let height;
        if(toControl.height!==undefined &&toControl.height!=='auto'){
          height = parseInt(toControl.height);
        }else{
          height = toControl.el.offsetHeight;
        }
        
        if(top>oldTop+height-size){
          top = oldTop+height-size;
        }
      }else{
        const oldLeft = parseInt(toControl.left);
        
        let width;
        if(toControl.width!==undefined &&toControl.width!=='auto'){
          width = parseInt(toControl.width);
        }else{
          width = toControl.el.offsetWidth;
        }
        
        if(left>oldLeft+width-size){
          left = oldLeft+width-size;
        }
      }
    }



    if(fromControl){    
      if(options.orientation=='horizontal'){
        if(fromControl.left!==undefined){
          left = fromControl.left;            
        }else{
          fromControl.left = left;
        }

        if(fromControl.width!==undefined){
          this.width = fromControl.width;            
        }else{
          fromControl.width = this.width;
        }

        if(fromControl.right!==undefined){
          this.right = fromControl.right;
        }else{
          fromControl.right = this.right;
        }
        
        const fromTop = parseInt(fromControl.top);
        fromControl.height = top - fromTop;
        fromControl.bottom = 'auto';

      }else{
        if(fromControl.top!==undefined){
          top = fromControl.top;            
        }else{
          fromControl.top = top;
        }
        
        if(fromControl.height!==undefined){
          this.height = fromControl.height;
        }else{
          fromControl.height = this.height;
        }

        if(fromControl.bottom!==undefined){
          this.bottom = fromControl.bottom;            
        }else{
          fromControl.bottom = this.bottom;
        }

        const fromLeft = parseInt(fromControl.left);
        fromControl.width = parseInt(left) - fromLeft;
        fromControl.right = 'auto';        
        // console.log('fromControl.width: ',fromControl.width);
      }

      fromControl.render();
    }
    
    if(toControl){
      
      if(options.orientation=='horizontal'){
        // if(!toControl.bottom || toControl.bottom=='auto'){
        //   toControl.bottom = parseInt(toControl.top) + parseInt(toControl.height);
        //   toControl.height = 'auto';
        // }

        if(!fromControl){
          if(toControl.left!==undefined){
            left = toControl.left;            
          }else{
            toControl.left = left;
          }

          if(toControl.width!==undefined){
            this.width = toControl.width;            
          }else{
            toControl.width = this.width;
          }

          if(toControl.right!==undefined){
            this.right = toControl.right;
          }else{
            toControl.right = this.right;
          }
        }else{
          toControl.left = this.left;
          toControl.width = this.width;            
          toControl.right = this.right;
        }

        const oldTop = parseInt(toControl.top);
        
        // let height;
        // if(toControl.height!==undefined &&toControl.height!=='auto'){
        //   height = parseInt(toControl.height);
        // }else{
        //   height = toControl.el.offsetHeight;
        // }
        
        // if(top>oldTop+height-size){
        //   this.top = oldTop+height-size;
        // }

        toControl.top = parseInt(top) + parseInt(options.thickness);
        if(toControl.height!==undefined &&toControl.height!=='auto'){
          toControl.height = parseInt(toControl.height) - toControl.top + oldTop;
        }

        
      }else{
        // if(!toControl.right || toControl.right=='auto'){
        //   toControl.right = parseInt(toControl.left) + parseInt(toControl.width);
        //   toControl.width = 'auto';
        // }
        
        if(!fromControl){
          if(toControl.top!==undefined){
            top = toControl.top;            
          }else{
            toControl.top = top;
          }
          
          if(toControl.height!==undefined){
            this.height = toControl.height;
          }else{
            toControl.height = this.height;
          }

          if(toControl.bottom!==undefined){
            this.bottom = toControl.bottom;            
          }else{
            toControl.bottom = this.bottom;
          }         
        }else{
          toControl.top = top;
          toControl.height = this.height;            
          toControl.bottom = this.bottom;
        }
        
        const oldLeft = parseInt(toControl.left);
        
        // let width;
        // if(toControl.width!==undefined &&toControl.width!=='auto'){
        //   width = parseInt(toControl.width);
        // }else{
        //   width = toControl.el.offsetWidth;
        // }
        
        // if(left>oldLeft+width-size){
        //   this.left = oldLeft+width-size;
        // }

        toControl.left = parseInt(left) + parseInt(options.thickness);
        if(toControl.width!==undefined &&toControl.width!=='auto'){
          toControl.width = parseInt(toControl.width) - toControl.left + oldLeft;
        }

      }

      toControl.render();
      // console.log('toControl.left/width: ',toControl.left,toControl.width);
    }

    if(this.left!==left){
      this.left=left;
    }

    if(this.top!==top){
      this.top=top;
    }
    

    if(render &&(fromControl||toControl)){
      this.render();
    }

    // console.log('splitter left/top: ', this.left,this.top);
  }

  onDragStart(e) {
    super.onDragStart(e);

    if(this._dragStart){
      
      this._dragStart.parentWidth = this.el.parentNode.offsetWidth;
      this._dragStart.parentHeight = this.el.parentNode.offsetHeight;
      this._dragStart.splitterSize = parseInt(this._controlOptions.thickness);

      const fromControl = this.fromControl;
      const toControl = this.toControl;

      if(fromControl){
        // fromControl.suspended = true;
        this._dragStart.fromTransition = _.get(fromControl._controlOptions,['style','normal','transitionDuration'],'');
        this._dragStart.fromOverflow = _.get(fromControl._controlOptions,['style','normal','overflow'],'');
        this._dragStart.fromPoinerEvents = _.get(fromControl._controlOptions,['style','normal','pointerEvents'],'');
        fromControl.el.style.setProperty('transitionDuration', '0s', 'important');
        fromControl.el.style.setProperty('overflow', 'hidden', 'important');        
        fromControl.el.style.setProperty('pointerEvents', 'none', 'important');        
      }
      
      if(toControl){
        // toControl.suspended = true;
        this._dragStart.toTransition = _.get(toControl._controlOptions,['style','normal','transitionDuration'],'');
        this._dragStart.toOverflow = _.get(toControl._controlOptions,['style','normal','overflow'],'');
        this._dragStart.toPoinerEvents = _.get(toControl._controlOptions,['style','normal','pointerEvents'],'');
        toControl.el.style.setProperty('transitionDuration', '0s', 'important');
        toControl.el.style.setProperty('overflow', 'hidden', 'important');   
        toControl.el.style.setProperty('pointerEvents', 'none', 'important');              
        
      }      
    }
  }

  onDragEnd(e) {
    if(this._dragStart){
      const dragStart = this._dragStart;
      
      _.defer(()=> {
        this.syncControls();
        const fromControl = this.fromControl;
        const toControl = this.toControl;
        
        if(fromControl){
          fromControl.el.style.transitionDuration = dragStart.fromTransition;
          fromControl.el.style.overflow = dragStart.fromOverflow;
          fromControl.el.style.pointerEvents = dragStart.fromPoinerEvents;
          // fromControl.suspended = false;
        }

        if(toControl){
          toControl.el.style.transitionDuration = dragStart.toTransition;
          toControl.el.style.overflow = dragStart.toOverflow;          
          toControl.el.style.pointerEvents = dragStart.toPoinerEvents;          
          // toControl.suspended = false;
        }
      });
    }

    super.onDragEnd(e);
  }

  onDragMove(e) {
    let ev = e;
    if(this._dragStart){
      ev = {
        pointerId:e.pointerId,
        clientX:e.clientX,
        clientY:e.clientY
      };
      if(this._controlOptions.orientation == 'horizontal'){
        ev.clientX = this._dragStart.clientX;
        if(this._dragStart.from){
          const top = this._dragStart.from.top + e.clientY - this._dragStart.clientY;

          if(top<1){
            ev.clientY=1 +this._dragStart.clientY-this._dragStart.from.top;
          }

          if(top>this._dragStart.parentHeight-this._dragStart.splitterSize - 1){
            ev.clientY=this._dragStart.parentHeight-this._dragStart.splitterSize+this._dragStart.clientY-this._dragStart.from.top +1;
          }          
        }
      }else{
        ev.clientY = this._dragStart.clientY;

        if(this._dragStart.from){
          const left = this._dragStart.from.left + e.clientX - this._dragStart.clientX;

          if(left<1){
            ev.clientX=1 + this._dragStart.clientX-this._dragStart.from.left;
          }

          if(left>this._dragStart.parentWidth-this._dragStart.splitterSize - 1){
            ev.clientX=this._dragStart.parentWidth-this._dragStart.splitterSize+this._dragStart.clientX-this._dragStart.from.left +1;
          }          
        }
      }      
      
    }

    super.onDragMove(ev);

    if(this._dragStart){
      this.syncControls();
    }
  }

  onDragCancel(e){
    if(this._dragStart){
      const fromTransition = this._dragStart.fromTransition;
      const toTransition = this._dragStart.toTransition;
      _.defer(()=> {
        this.syncControls();
        
        const fromControl = this.fromControl;
        const toControl = this.toControl;
        
        if(fromControl){
          _.set(fromControl._controlOptions,['style','normal','transitionDuration'],fromTransition);
          // fromControl.suspended = false;
        }

        if(toControl){
          _.set(toControl._controlOptions,['style','normal','transitionDuration'],toTransition);
          // toControl.suspended = false;
        }
      });
    }

    super.onDragMove(e);
  }

  syncValue(value, render){
    value = parseInt(value);
    if(this._controlOptions.orientation=='horizontal'){
      if(this.top !== value){
        this.top = value;
        this.syncControls(render);              
      }
    }else{
      if(this.left !== value){
        this.left = value;
        this.syncControls(render);              
      }
    }
  }

  onReady(){
    // if(!this.isLayoutMode){
      this.instance.on('ready',() => {
        if(this._controlOptions.orientation=='horizontal'){
          if(this.top !== this.value){
            this.top = this.value;
          }
        }else{
          if(this.left !== this.value){
            this.left = this.value;
          }
        }

        this.syncControls(true);
      });
      this.addTrigger('value', (event, control, component, anchor, [{value,oldValue}])=>{
        if(value!==oldValue){
          this.syncValue(value,true);
        }
      });

      this.addTrigger('left',(event, control, component, anchor, [{value,oldValue}])=>{
        if(value!==oldValue &&
            this.value !== value &&
            this._controlOptions.orientation!=='horizontal'){
          // console.log(this.path+': ',this.value,' -> ',value);
          this.value = value;
          this.syncControls(true);              
        }
      });

      this.addTrigger('top',(event, control, component, anchor, [{value,oldValue}])=>{
        if(value!==oldValue &&
            this.value !== value &&
            this._controlOptions.orientation=='horizontal'){

          this.value = value;
          this.syncControls(true);              
        }
      });

      // this.syncValue(this.value, false);
    // }
  }

  
  renderElement() {
    const control = this;
    // const options = this._controlOptions;
    const options = this.options;
    if(!options.thickness) {options.thickness = 8;}

    // const instance = this.instance;
    if (!control.el) {
      control.el = getDefaultControl();
      if(!control.id){
        control.id = uniqueId(control.el, 'recharts-splitter-',Splitter);
        control.styleSheet = 'css-' + control.id;        
      }else{
        control.el.setAttribute('id',control.id);
      }      
    }

    updateClasses(control,options);
    var bodyEl = control.el.getElementsByClassName('body')[0];
    

    var frameStylePatch = _.pick(merge(
      {},
      getDefaultStyle(),
      options.orientation == 'horizontal'? horisontalFrame:verticalFrame,
      options.style.normal,
      options.orientation == 'horizontal'? {height:options.thickness+'px'}:{width:options.thickness+'px'},
      ),
    frameProps);
    

    let scheme = lookAndFeel(options.lookAndFeel, options.style.normal.height);
    
    updateStyleByRef(frameStylePatch, scheme);
    updateStyle(control.el, frameStylePatch, control._styleCache.currentFrameStyle);
    
    control._styleCache.currentFrameStyle = frameStylePatch;
    
    // bodyEl.innerHTML = control.text || '';

    return control.el;
  }
}
